module.exports = __webpack_public_path__ + "static/media/popup-image.04ef5949.jpeg";